<template>
  <div class="error-container">
    <h3>{{ header }}</h3>
    <div>{{ subHeader }}</div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  computed: {
    header() {
      const state = window.history?.state;
      return state?.header || 'Unexpected Error';
    },
    subHeader() {
      const state = window.history?.state;
      return state?.subHeader || 'An error has occurred';
    },
  },
};
</script>

<style lang="scss" scoped>
.error-container {
  width: 100%;
  margin: 15px;
}
</style>
